import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidationErrors, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ScheduleBranchDays } from '@app/shared/models/schedule-branch-days.model';
import { ScheduleBranchService } from '@app/shared/services/shedule-branch.service';
import { ScheduleNewBranchDays } from '@app/shared/models/schedule-new-branch-day.model';
import * as moment from 'moment';

@Component({
  selector: 'app-day-schedule',
  templateUrl: './day-schedule.component.html',
  styleUrls: ['./day-schedule.component.scss']
})
export class DayScheduleComponent {
  sheduleForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { schedule: ScheduleBranchDays; hasDelivery: boolean; },
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DayScheduleComponent>,
    private scheduleService: ScheduleBranchService
  ) {
    this.createForm();

    if (this.data.schedule) {
      this.sheduleForm.controls.ID.setValue(this.data.schedule.id);
    }
  }

  createForm(): void {
    if (!this.data.schedule) {
      this.data.schedule = new ScheduleBranchDays();
    }

    this.sheduleForm = this.fb.group({
      OpeningHour: [this.convertToDate(this.data.schedule.openingHour), Validators.required],
      ClosingHour: [this.convertToDate(this.data.schedule.closingHour), Validators.required],
      OpeningHourDelivery: [this.convertToDate(this.data.schedule.openingHourDelivery), this.hasDeliveryValidator],
      ClosingHourDelivery: [this.convertToDate(this.data.schedule.closingHourDelivery), this.hasDeliveryValidator],
      DayOfWeek: [this.data.schedule.dayOfWeek],
      BranchID: [this.data.schedule.branchID],
      ID: [0]
    });
  }

  close(newShedule?: ScheduleBranchDays, isNew?: boolean): void {
    if (newShedule && Object.keys(newShedule).length) {
      newShedule.isNew = isNew;
    }

    this.dialogRef.close(newShedule || this.data.schedule);
  }

  save(): void {
    const newBranchDay = this.getValues();
    this.scheduleService.save(newBranchDay).subscribe((branchDay) => {
      this.close(branchDay, newBranchDay.ID ? false : true);
    },() => { });
  }

  hasDeliveryValidator = (control: FormControl): ValidationErrors | null => {
    const hasDelivery = this.data.hasDelivery;
    return hasDelivery && !control.value ? { 'HourDelivery': true } : null;
  }

  convertToDate(date: any): Date {
    return date && date instanceof Date || !isNaN(new Date(date).getTime())
      ? new Date(date)
      : (date ? date : '');
  }

  getValues(): ScheduleNewBranchDays {
    const today = moment().format('YYYY-MM-DD HH:mm:ss');
    const newDay = new ScheduleNewBranchDays();
    newDay.BranchID = Number(this.sheduleForm.get('BranchID').value);
    newDay.DayOfWeek = Number(this.sheduleForm.get('DayOfWeek').value);
    newDay.ID = this.sheduleForm.get('ID').value ? Number(this.sheduleForm.get('ID').value) : 0;
    newDay.OpeningHour = this.formatDate(this.sheduleForm.get('OpeningHour').value);
    newDay.OpeningHourDelivery = this.data.hasDelivery ? this.formatDate(this.sheduleForm.get('OpeningHourDelivery').value) : today;
    newDay.ClosingHour = this.formatDate(this.sheduleForm.get('ClosingHour').value);
    newDay.ClosingHourDelivery = this.data.hasDelivery ? this.formatDate(this.sheduleForm.get('ClosingHourDelivery').value) : today;

    return newDay;
  }

  formatDate(date: string): string {
    return moment(date, 'h:mm a').format('YYYY-MM-DD HH:mm:ss');
  }
}
